export default "__VITE_ASSET__4f4161b3__"